import React from 'react';
import { Button, Container, Loader } from 'semantic-ui-react';
import { ObjectTypeType } from '@constants/objectType';
import useGetInspection from '@api/inspection/hooks/useGetInspection';
import useGetInspectedObjectDetails from '@api/objectDetails/hooks/useGetInspectedObjectDetails';

function SailorLink({
  inspectionSummaryId,
  objectId,
  objectType,
  inspectionId,
}: {
  inspectionSummaryId: number;
  objectId: number | undefined;
  objectType: ObjectTypeType;
  inspectionId: number | undefined;
}) {
  const { inspectionDTO, isFetchingInspectionDTO } = useGetInspection(Number(inspectionId), {
    enabled: !!inspectionId,
  });
  const { objectDetailsDTO, isFetchingObjectDetailsDTO } = useGetInspectedObjectDetails(
    Number(inspectionSummaryId),
    true,
    {
      enabled: !!inspectionSummaryId,
    }
  );
  if (inspectionId && objectId) {
    const url = `${window.REACT_APP_SAILOR_URL}/${objectType.urlSubString}/${objectId}?inspection=${inspectionId}`;
    const statusColor = inspectionDTO?.color;
    return isFetchingInspectionDTO ? (
      <Loader active inline size="tiny" />
    ) : (
      <Container
        onClick={(e: Event) => {
          e.stopPropagation();
        }}
      >
        <Button target="_blank" href={url} size="tiny" basic>
          <span
            style={{
              backgroundColor: statusColor,
              width: '10px',
              height: '10px',
              display: 'inherit',
              marginRight: '5px',
            }}
          />
          {inspectionDTO?.status}
        </Button>
      </Container>
    );
  }
  if (!inspectionId && objectId) {
    const url = `${window.REACT_APP_SAILOR_URL}/${objectType.urlSubString}/${objectId}`;
    return isFetchingObjectDetailsDTO ? (
      <Loader active inline size="tiny" />
    ) : (
      <Container
        onClick={(e: Event) => {
          e.stopPropagation();
        }}
      >
        <Button target="_blank" href={url} size="tiny" basic>
          {objectDetailsDTO?.objectName}
        </Button>
      </Container>
    );
  }
  return null;
}
export default SailorLink;
